import ApiService from './ApiService';

class SharePropertiesMultipleSourcesService {
  static async getContacts({ q = '', filter = true, page = 1, limit = 25 }) {
    const safeQuery = q?.trim() ? `q=${encodeURIComponent(q)}` : 'q';
    const composedURL = `/api3/contact/?${safeQuery}&with_valid_cellphone=true&filter_on_es=${filter}&page=${page}&limit=${limit}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async postValidateContactChannel(data) {
    const contactId = data.contact.id;
    const composedURL = `/api3/tokko_chat/channel/member-info?contact_id=${contactId}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async postCreateMessageContact(data) {
    const contactId = data.contact.id;
    const composedURL = `/api3/tokko_chat/messages/contact/${contactId}`;
    const response = await ApiService.post(composedURL, data);
    return response;
  }
}

export default SharePropertiesMultipleSourcesService;
